var React = require('react');

function LogoLinkedin (props) {
    return React.createElement("svg",props,[React.createElement("g",{"key":0},React.createElement("path",{"d":"M20.4 20.4H16.8V14.04C16.8 13.044 15.996 12.24 15 12.24C14.004 12.24 13.2 13.044 13.2 14.04V20.4H9.6V9.6H13.2V11.04C13.8 10.032 15.108 9.36 16.2 9.36C18.516 9.36 20.4 11.244 20.4 13.56V20.4ZM5.4 7.572C4.2 7.572 3.228 6.6 3.228 5.4C3.228 4.2 4.2 3.228 5.4 3.228C6.6 3.228 7.572 4.2 7.572 5.4C7.572 6.6 6.6 7.572 5.4 7.572ZM7.2 20.4H3.6V9.6H7.2V20.4ZM21.6 0H2.4C1.068 0 0 1.068 0 2.4V21.6C0 22.92 1.08 24 2.4 24H21.6C22.92 24 24 22.92 24 21.6V2.4C24 1.068 22.92 0 21.6 0V0Z","fill":"currentColor"})),React.createElement("defs",{"key":1},React.createElement("clipPath",null,React.createElement("rect",{"width":"24","height":"24","fill":"white"})))]);
}

LogoLinkedin.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = LogoLinkedin;

LogoLinkedin.default = LogoLinkedin;
